import React from 'react'
import Link from 'gatsby-link'
import SocialIcon from '../Social/socialIcon'
import CookiesLink from '../Linking/cookiesLink'

const Footer = () => (
    <footer>
        <p>&copy; {new Date().getFullYear()} Gorka Muñoz | {<Link to="/sitemap.xml"> Sitemap </Link> } | <CookiesLink/> | <Link to="/sobre-mi">Contacto</Link></p>
        <div className="social">
        {/*All fontawesome icon names: https://fontawesome.com/icons?d=gallery*/}
        <SocialIcon style={{position:"relative", top:"-2px"}} link="https://www.linkedin.com/in/gorka-muñoz" iconName="linkedin-in" title="LinkedIn" ariaLabel="LinkedIn social icon"/> 
        <SocialIcon link="https://twitter.com/gmugart" iconName="twitter" title="Twitter" ariaLabel="Twitter social icon"/> 
        <SocialIcon link="https://codepen.io/gmugart/" iconName="codepen" title="Codepen" ariaLabel="Codepen social icon"/> 
        <SocialIcon link="https://www.behance.net/gmugart" iconName="behance" title="Behance" ariaLabel="Behance social icon"/> 
        </div>
    </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/footer.js